var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isUser)?_c('core-card-foot-item',[_c('core-divisive',{attrs:{"score":_vm.item.users.divisiveness,"count":_vm.item.users.totalRatings}}),_c('core-card-foot-item-label',[_vm._v(_vm._s(_vm.field.label))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }